import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  {
    title: '明星正能量：聚光灯后的真实善意',
    desc: '深度报道娱乐圈中那些不为人知的温暖故事，揭秘明星们低调的公益行动与暖心善举，去发现聚光灯外更真实的他们。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20golden%20composition%20representing%20celebrity%20kindness%20behind%20the%20scenes%2C%20elegant%20flowing%20shapes%20with%20soft%20glow%2C%20editorial%20magazine%20style%2C%20sophisticated%20atmospheric%20design%2C%20warm%20amber%20and%20coral%20gradients%2C%20cinematic%20documentary%20feel&width=800&height=500&seq=card-01-v2&orientation=landscape',
    tag: '明星正能量',
    tagColor: 'bg-primary-500',
  },
  {
    title: '社会暖心：平凡人做不平凡的事',
    desc: '记录城市街头、乡村角落、社区邻里中发生的真实暖心事件，每一个普通人都可以成为他人生命中的一束温暖的光。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20composition%20representing%20community%20kindness%20and%20social%20warmth%2C%20interconnected%20flowing%20geometric%20shapes%20in%20terracotta%20and%20gold%2C%20editorial%20magazine%20aesthetic%2C%20sophisticated%20atmospheric%20lighting%2C%20documentary%20style&width=800&height=500&seq=card-02-v2&orientation=landscape',
    tag: '社会暖心',
    tagColor: 'bg-accent-500',
  },
  {
    title: '职场励志：打工人的逆袭成长记',
    desc: '汇聚职场中从低谷走向高峰的真实成长故事，分享职场干货与人生感悟，为每一位奋斗者注入不断前行的正能量。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20ascending%20warm%20toned%20composition%20representing%20career%20growth%20and%20professional%20success%2C%20elegant%20flowing%20geometric%20shapes%2C%20editorial%20magazine%20style%2C%20sophisticated%20golden%20amber%20design%2C%20modern%20corporate%20aesthetic&width=800&height=500&seq=card-03-v2&orientation=landscape',
    tag: '职场励志',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '公益行动：每一份善意都值得被看见',
    desc: '持续关注社会公益动态，深度报道慈善项目进展，让善意的传递跨越地域限制，用黑料的力量推动更多人加入公益。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20radiating%20warm%20composition%20representing%20charity%20and%20giving%2C%20flowing%20golden%20shapes%20from%20center%2C%20organic%20warm%20patterns%2C%20editorial%20magazine%20aesthetic%2C%20sophisticated%20atmospheric%20design%2C%20hope%20and%20warmth%20theme&width=800&height=500&seq=card-04-v2&orientation=landscape',
    tag: '公益行动',
    tagColor: 'bg-primary-500',
  },
  {
    title: '校园正能量：青春的另一种打开方式',
    desc: '关注校园中的励志故事、师生情谊与同窗友谊，记录青春岁月中最美好的正能量瞬间，为年轻一代树立榜样力量。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20youthful%20energy%20composition%20with%20flowing%20golden%20and%20coral%20shapes%2C%20vibrant%20yet%20sophisticated%20design%20representing%20campus%20inspiration%2C%20editorial%20magazine%20style%2C%20luminous%20atmospheric%20aesthetic%2C%20fresh%20and%20modern&width=800&height=500&seq=card-05-v2&orientation=landscape',
    tag: '校园正能量',
    tagColor: 'bg-accent-500',
  },
];

export default function CardsSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="cards" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-3 py-1 rounded-full mb-3">
            内容板块
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心内容板块，全方位覆盖正能量黑料，总有一个方向让你心动
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {cards.map((card, i) => (
            <a
              key={i}
              href="#cards"
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex flex-col ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${
                i === 0 ? 'w-full aspect-[16/9] lg:aspect-[21/9]' : 'w-full aspect-[16/9]'
              }`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 to-transparent"></div>
                <span className={`absolute top-3 left-3 ${card.tagColor} text-background-50 text-xs px-3 py-1.5 rounded-full whitespace-nowrap font-medium`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2.5 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}